module.exports = "/images/Collect Custumer information2 1.svg?4be6064a06d468e546f44945895c9f8d";